export default __webpack_public_path__ + "static/media/email.dbcbb3e8.png";